import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth/auth.service';
import { LocalStorageService } from 'src/app/services/storage/storage.service';
import { getDeepLink, getDestination, LINK_ROUTER_PARAM } from './link-router.routes';

@Component({
  selector: 'mpp-link-router',
  template: '',
  standalone: false,
})
export class LinkRouterComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private localStorage: LocalStorageService,
  ) {}

  async ngOnInit(): Promise<void> {
    const deepLink = getDeepLink(
      this.activatedRoute.snapshot.queryParamMap.get(LINK_ROUTER_PARAM),
    );
    const destination = getDestination(deepLink);

    if (destination === '/support') {
      await this.router.navigate([destination]);
      return;
    }

    if (await this.authService.checkAuthenticated()) {
      this.localStorage.removeItem(this.localStorage.linkRouterRedirect);
      await this.router.navigate([destination]);
      return;
    }

    this.localStorage.setItem(this.localStorage.linkRouterRedirect, destination);
    const redirectCountry = this.activatedRoute.snapshot.queryParamMap.get('redirectCountry');
    await this.router.navigate(['/'], {
      queryParams: {
        [LINK_ROUTER_PARAM]: deepLink,
        ...(redirectCountry && { redirectCountry }),
      },
    });
  }
}